import { useEffect, useState } from 'react';
import type { PlayerCampaignTheme } from '@playcastdotio/Messaging';
import { fetchActiveCampaignThemes } from '../api/modules/campaigns';

type UseActiveCampaignsResult = {
  campaigns: PlayerCampaignTheme[];
  loading: boolean;
  error: string | null;
};

export const useActiveCampaigns = (): UseActiveCampaignsResult => {
  const [campaigns, setCampaigns] = useState<PlayerCampaignTheme[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    const loadCampaigns = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await fetchActiveCampaignThemes();
        if (!cancelled) {
          setCampaigns(data);
        }
      } catch (err) {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : 'Failed to load campaigns');
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadCampaigns();

    return () => {
      cancelled = true;
    };
  }, []);

  return { campaigns, loading, error };
};
